<template>
<section id="signin">
    <NavbarDefault />
    <div class="container-fluid layout d-flex flex-column justify-content-center">
        <div class="row">
            <div class="col mt-5">
                <div class="mx-auto mt-4" style="max-width: 432px">
                    <h2 :class="`c-${getPrimaryColor}four`">Primeiro insira o CNPJ da sua empresa</h2>
                    <p class="c-ndarkfour regular">Vamos verificar se seu cliente já possui cadastro com a gente</p>

                    <el-form :model="user" ref="user" :rules="rules" class="mt-5">
                        <el-form-item prop="cnpj" class="my-4">
                            <label>CNPJ</label>
                            <el-input 
                                class="input-signup"
                                :class="getPrimaryColor"
                                v-model="user.cnpj"
                                v-mask="'##.###.###/####-##'"
                                placeholder="CNPJ da empresa"
                                @keyup.native="validateForm()"
                            />
                        </el-form-item>
                    </el-form>

                    <button :class="`btn btn-${getPrimaryColor} w-100 justify-content-center mt-3`" :disabled="!buttonDisabled" @click.prevent.stop="nextStep">
                        Continuar
                    </button>
                    <p :class="`mt-4 text-center ${getWhiteLabel === 'CIABRA' ? 'mb-4' : 'mb-5'} `">
                        Já possui uma conta?
                        <router-link to="/">
                            <span :class="`c-${getPrimaryColor}four`">
                                Faça login.
                            </span>
                        </router-link>
                    </p>

                    <div class="d-flex justify-content-center align-content-center" v-if="getWhiteLabel === 'CIABRA'" >
                        <PoweredByColorful class="mt-5" color="#0A735A" />
                    </div>
                </div>
            </div>
            <SignUpImage />
        </div>
    </div>
    <FooterSide />
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import FooterSide from '@/components/navigation/footer/FooterSide'
import PoweredByColorful from '@/components/icons/PoweredByColorful'
import FullLoading from '@/components/loading/FullLoading'
import removeMask from '@/utils/removeMask'
import signUp from '@/api/signUp'
import SignUpImage from '@/views/signUp/SignUpImage.vue'


export default {
    components: {
        NavbarDefault,
        FooterSide,
        PoweredByColorful,
        FullLoading,
        SignUpImage,
    },
    data() {
        return {
            user: {
                cnpj:'',
            },
            rules: {
                cnpj: [
                    {
                        required: true,
                        message: 'Por favor, insira o CNPJ da sua empresa',
                        trigger: 'change'
                    },
                    {
                        min: 18,
                        message: 'O CNPJ deve ter 14 caracteres',
                        trigger: 'change'
                    }
                ],
            },
            formValid: false,
            cnpjOk: false,
            dialogVisible: false,
        }
    },
    computed: {
        buttonDisabled() {
            return this.formValid
        }
    },
    methods: {
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async nextStep() {
            const result = await signUp({
                cnpj: removeMask(this.user.cnpj)
            }, true)

            if (result.ok) {
                this.$store.commit('register/setCompany', { ...result.payload.company, cnpj: result.payload.cnpj })
                this.$store.commit('user/setCnpj', result.payload.cnpj.cnpj)
                return this.$router.push('/signup/located')
            } else if (result.message == 'company already has an admin user registered') {
                this.$store.commit('register/setUser', result.payload)
                return this.$router.push('/signup/alreadyregistered')
            } else {
                if (result.message == 'cannot found cnpj') {
                    return this.$router.push('/signup/invite')
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    })
                }
            }
        }
    },
    created(){
        this.$store.commit('user/setLoading', false)
    }
}
</script>

<style scoped>
</style>
